import { NewsPreview } from "../../../api/newsfeed.types";
import { NewsAllAction } from "./news.all.types";

export const newsAllRequestAction = (): NewsAllAction => ({ type: 'NEWS_ALL_REQUEST' })
export const newsAllSuccessAction = (news: NewsPreview[]): NewsAllAction => ({ type: 'NEWS_ALL_SUCCESS', params: news })
export const newsAllFailureAction = (error?: any): NewsAllAction => ({ type: 'NEWS_ALL_FAILURE', params: error })